/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of the field
 */
export enum DocumentFields {
    CLASSIFIERS = 'classifiers',
    DOCUMENT_TITLE = 'documentTitle',
    FILE_NAME = 'fileName',
    FILE_SIZE = 'fileSize',
    UPLOAD_DATE = 'uploadDate',
    RELATED_PEOPLE = 'relatedPeople',
    ASSOCIATED_TRANSACTIONS = 'associatedTransactions',
}
